var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    _vm._l(_vm.listData.avatars, function(avatar) {
      return _c("li", [
        _vm._m(0, true),
        _c("div", [
          _c("p", { staticClass: "text-medium black" }, [
            _vm._v(" " + _vm._s(avatar.text))
          ]),
          avatar.subtitle
            ? _c("p", { staticClass: "text-small black mg mg--t-1" }, [
                _vm._v(" " + _vm._s(avatar.subtitle))
              ])
            : _vm._e()
        ])
      ])
    }),
    0
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item__avatar" }, [
      _c("img", { attrs: { src: require("@/assets/logo_ma_orange.svg") } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }